import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimEmailTemplate.Save.IRequest;
type Response = Api.Core.ClaimEmailTemplate.Save.IResponse;
type Headers = Api.Core.ClaimEmailTemplate.Save.IHeaders;
const url = '/api/Management/ClaimEmailTemplate';
export default async function claimEmailTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
